{/* <svg width="348" height="210" viewBox="0 0 348 210" fill="none" xmlns="http://www.w3.org/2000/svg"> */}
import React from "react";
import clsx from 'clsx';
import { SvgIcon } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 348,
    height: 210,
    fill: "transparent",
    ['@media (max-width: 768px)']: {
      display: "block",
      width: "200px",
      margin: "auto",
      height: "auto"
    }
  }
});

class IlSentEmail extends React.Component {

  render() {
    const { classes, className } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    viewBox = { "0 0 348 210"  } >
      <path d="M320.197 27.7839V44.8282L328.563 32.9784" stroke="#1A1919" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M347 1L320.197 27.7839M301.517 20.4792L347 1L339.69 39.9584L320.197 27.7839L301.517 20.4792Z" stroke="#1A1919" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="11.5586" y="118" width="99.9014" height="65.8125" fill="#54BAC1" fillOpacity="0.3"/>
      <path d="M67.3348 137.645L100.502 171.353M1 171.353L34.1674 137.645M1 105.26L50.7511 153.177L100.502 105.26H1Z" stroke="#1A1919" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1 105.26H100.502V171.353H1V105.26Z" stroke="#1A1919" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M100.495 170.225C100.495 170.225 243.096 242.865 289.333 189.299C317.433 156.745 244.258 99.9477 274.713 69.583C289.283 55.0573 321.009 44.4224 321.009 44.4224" stroke="black" strokeWidth="2" strokeDasharray="6 6"/>
      <rect x="124.455" y="38.3352" width="61.7277" height="41.3933" fill="#004876" fillOpacity="0.4"/>
      <path d="M173.794 68.1974L194.403 89.1415M132.577 89.1415L153.186 68.1974M132.577 48.0747L163.49 77.8481L194.403 48.0747H132.577Z" stroke="#1A1919" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M132.577 48.0747H194.403V89.1415H132.577V48.0747Z" stroke="#1A1919" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M209.549 94.3379C209.549 102.75 202.724 109.571 194.305 109.571C185.885 109.571 179.061 102.75 179.061 94.3379C179.061 85.9258 185.885 79.1052 194.305 79.1052C202.724 79.1052 209.549 85.9258 209.549 94.3379Z" fill="white" stroke="#1A1919" strokeWidth="2"/>
      <path d="M186.183 93.932L192.68 100.425L202.833 87.8447" stroke="black" strokeWidth="2"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(IlSentEmail);
